module.exports = __webpack_public_path__ + "img/icon.7ce5ca65.png";